import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CommunicationTypePicker from './CommunicationTypePicker';
import * as api from './api';
import '../../css/modals.css';
import '../../css/communications.css';

// Kept minimal on purpose, same precedent as ExerciseTemplateCreateModal.jsx -
// only title+type up front, the actual rich-text content is authored right
// after on the Builder page this navigates to.
export default function CommunicationCreateModal({ isOpen, onClose }) {
   const navigate = useNavigate();
   const [title, setTitle] = useState('');
   const [type, setType] = useState('INFO');
   const [saving, setSaving] = useState(false);

   if (!isOpen) return '';

   const stopProp = (e) => e.stopPropagation();

   const handleClose = () => {
      setTitle('');
      setType('INFO');
      onClose();
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      if (saving || !title.trim()) return;
      setSaving(true);
      api.createNotification({ title: title.trim(), type, content: '' })
         .then((response) => {
            handleClose();
            navigate('/communications/' + response.data.id);
         })
         .catch((err) => {
            if (err.response && err.response.status === 401) navigate('/login');
            console.log(err);
         })
         .finally(() => setSaving(false));
   };

   return (
      <div className='modal-update' onClick={handleClose} style={{ display: 'flex' }}>
         <div className='modal-window' onClick={stopProp}>
            <h3 className='modal-w-title'>Нове повідомлення</h3>
            <form onSubmit={handleSubmit}>
               <div className='flex-from-input-wraper exercise-template-field' data-label='Назва'>
                  <input className='submit-field from-input txt-c' type='text' autoFocus
                     placeholder='Назва' value={title} onChange={(e) => setTitle(e.target.value)} />
               </div>
               <CommunicationTypePicker value={type} onChange={setType} showHint />
               <button type='submit' className='form-button txt-c' disabled={saving || !title.trim()} style={{ marginTop: 14 }}>
                  {saving ? 'Завантаження...' : 'Створити'}
               </button>
            </form>
         </div>
      </div>
   );
}
